import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import WarehosueForm from "./WarehouseForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { warehouseValidationForm } from "../../utils/validationSchemas";

const EditWarehouse = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    control,
  } = useForm<any>({
    resolver: yupResolver(warehouseValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        manager: data?.data?.warehouse_manager,
        name: data?.data?.name,
        city: data?.data?.city,
        country: data?.data?.country,
        state: data?.data?.state,
        district: data?.data?.district,
        landmark: data?.data?.landmark,
        primary_contact: data?.data?.primary_contact,
        secondary_contact: data?.data?.primary_contact,
        primary_email: data?.data?.primary_email,
      };
    },
  });

  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <WarehosueForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        control={control}
      />
    </FormLayout>
  );
};

export default EditWarehouse;
